/* tslint:disable */
import {
  RoleData,
  UserData
} from '../index';

declare var Object: any;
export interface UserRoleInterface {
  "paymentType": number;
  "id"?: number;
  "principalType"?: string;
  "principalId"?: number;
  "roleId"?: number;
  role?: RoleData;
  user?: UserData;
}

export class UserRole implements UserRoleInterface {
  "paymentType": number;
  "id": number;
  "principalType": string;
  "principalId": number;
  "roleId": number;
  role: RoleData;
  user: UserData;
  constructor(data?: UserRoleInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `UserRole`.
   */
  public static getModelName() {
    return "UserRole";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of UserRole for dynamic purposes.
  **/
  public static factory(data: UserRoleInterface): UserRole{
    return new UserRole(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'UserRole',
      plural: 'UserRoles',
      path: 'UserRoles',
      idName: 'id',
      properties: {
        "paymentType": {
          name: 'paymentType',
          type: 'number',
          default: 0
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "principalType": {
          name: 'principalType',
          type: 'string'
        },
        "principalId": {
          name: 'principalId',
          type: 'number'
        },
        "roleId": {
          name: 'roleId',
          type: 'number'
        },
      },
      relations: {
        role: {
          name: 'role',
          type: 'RoleData',
          model: 'RoleData',
          relationType: 'belongsTo',
                  keyFrom: 'roleId',
          keyTo: 'id'
        },
        user: {
          name: 'user',
          type: 'UserData',
          model: 'UserData',
          relationType: 'belongsTo',
                  keyFrom: 'principalId',
          keyTo: 'id'
        },
      }
    }
  }
}
